// Shared scroll-reveal trigger (Brick 3). Lightweight, no framework:
// IntersectionObserver flips .is-visible once per element, then stops
// observing it. Respects prefers-reduced-motion by revealing everything
// immediately instead of animating.
(function () {
  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function revealAllImmediately() {
    document.querySelectorAll(".reveal-on-scroll").forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  if (prefersReduced || !("IntersectionObserver" in window)) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", revealAllImmediately);
    } else {
      revealAllImmediately();
    }
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -40px 0px" },
  );

  function observeAll() {
    document.querySelectorAll(".reveal-on-scroll").forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeAll);
  } else {
    observeAll();
  }
})();
